<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
              @keyup.enter.native="searchQuery">
        <div class="div-query-banner">
          <a-form-item label="访客状态">
            <j-dict-select-tag v-model="queryParam.docstatus"
                               :triggerChange="false"
                               dictCode="visitor_hd_status"
                               :selectClear="true"></j-dict-select-tag>
          </a-form-item>
          <a-form-item label="访客类型">
            <j-dict-select-tag v-model="queryParam.doctype"
                               :triggerChange="false"
                               dictCode="visitor_hd_doctype"
                               :selectClear="true"></j-dict-select-tag>
          </a-form-item>


          <a-form-item label="访客姓名">
            <j-input v-model="queryParam.bkname"></j-input>
          </a-form-item>
          <a-form-item label="访客电话">
            <j-input v-model="queryParam.bktel"></j-input>
          </a-form-item>
          <a-form-item label="接待人">
            <j-input v-model="queryParam.jdname"></j-input>
          </a-form-item>
          <a-form-item label="接待人电话">
            <j-input v-model="queryParam.jdtel"></j-input>
          </a-form-item>

          <!-- <a-form-item label="接待位置">
            <j-input v-model="queryParam.place"></j-input>
          </a-form-item> -->

          <a-form-item label="接待位置">
              <j-dict-select-tag 
                v-model="queryParam.place" 
                :triggerChange="false"
                dictCode="visitor_hd_jdplace"
                :selectClear="true"  
              />
            </a-form-item>



          <a-form-item label="拜访原因">
            <j-input v-model="queryParam.whystr"></j-input>
          </a-form-item>
          <a-form-item label="取消原因">
            <j-input v-model="queryParam.cancelmemo"></j-input>
          </a-form-item>

          <a-form-item label="拜访时间">
            <a-range-picker 
              show-time 
              format="YYYY-MM-DD" 
              @change="getNewDate" 
              style="margin-right: 2%"
            />
          </a-form-item>

          <a-button class="query-banner-btn"
                    type="primary"
                    @click="searchQuery"
                    icon="search">查询</a-button>
          <a-button class="query-banner-btn"
                    type="primary"
                    @click="searchReset"
                    icon="reload"
                    style="margin-left: 8px">重置</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <div>
        <a-button @click="handleAdd"
                  type="primary"
                  icon="plus">新增访客</a-button>
        <a-button style="margin-left: 8px"
                  @click="handleCancelClick">取消拜访</a-button>
      </div>

      <a-upload name="file"
                :multiple="true"
                :action="importExcelUrl"
                :headers="headers"
                @change="handleChange">
        <a-button>
          <a-icon type="upload" /> 导入访客信息
        </a-button>
      </a-upload>
      <a-button style="margin-left: 8px" @click="downloadTemplate">下载模板</a-button>

      <a-button style="margin-left: 8px" @click="handleExportXls('访客')" v-if="isShowExport" type="primary" >导出</a-button>

    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info"
           style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px"
           @click="onClearSelected">清空</a>
      </div>

      <a-table ref="table"
               size="middle"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="rowSelection"
               :scroll="{x:true}"
               @change="handleTableChange">
        <template slot="htmlSlot"
                  slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot"
                  slot-scope="text">
          <span v-if="!text"
                style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else
               :src="getImgView(text)"
               height="25px"
               alt="图片不存在"
               style="max-width:80px;font-size: 12px;font-style: italic;" />
        </template>
        <template slot="fileSlot"
                  slot-scope="text">
          <span v-if="!text"
                style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button v-else
                    :ghost="true"
                    type="primary"
                    icon="download"
                    size="small"
                    @click="uploadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="action"
              slot-scope="text, record">
          <a @click="handleEditNew(record)">查看详情</a>
        </span>
      </a-table>
    </div>
    <visitor-modal ref="modalForm"
                   @ok="modalFormOk"></visitor-modal>
    <a-modal title="取消原因"
             :visible="crModalvisible"
             :confirm-loading="crConfirmLoading"
             @ok="handleCROk"
             @cancel="handleCRCancel">
      <a-input v-model="cancelReason"
               placeholder="请输入取消原因！"></a-input>
    </a-modal>
  </a-card>
</template>

<script>

import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import VisitorModal from './modules/VisitorModal'
import JInput from '@/components/jeecg/JInput.vue'
import { cancelVistors, ajaxGetDictItems } from '@/api/api.js'
import { getVisitorConfigList, getFindRoleByUserNo } from '@/api/api.js'
import { mapMutations } from 'vuex'
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
const token = Vue.ls.get(ACCESS_TOKEN);
export default {
  name: "VisitorList",
  mixins: [JeecgListMixin],
  components: {
    VisitorModal, JInput
  },
  mounted () {
    this.getdatalist();
    this.findRoleByUserNo()
  },
  data () {
    return {
      description: '访客表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '状态',
          align: "center",
          dataIndex: 'states'
        },
        {
          title: '拜访类型',
          align: "center",
          dataIndex: 'doctype'
        },
        {
          title: '拜访时间',
          align: "center",
          dataIndex: 'docdate',
          customRender: function (text) {
            return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
          }
        },
        {
          title: '宾客名',
          align: "center",
          dataIndex: 'bkname'
        },
        {
          title: '电话',
          align: "center",
          dataIndex: 'bktel'
        },
        {
          title: '验证码',
          align: "center",
          dataIndex: 'checkstr'
        },
        {
          title: '接待人',
          align: "center",
          dataIndex: 'jdname'
        },
        {
          title: '接待电话',
          align: "center",
          dataIndex: 'jdtel'
        },
        {
          title: '接待位置',
          align: "center",
          dataIndex: 'place'
        },
        {
          title: '拜访原因',
          align: "center",
          dataIndex: 'whystr'
        },
        {
          title: '取消原因',
          align: "center",
          dataIndex: 'cancelmemo'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: "/visitor/base/visitor/list",
        delete: "/visitor/base/visitor/delete",
        deleteBatch: "/visitor/base/visitor/deleteBatch",
        exportXlsUrl: "/visitor/base/visitor/exportXls",
        importExcelUrl: "/visitor/base/visitor/importExcel"
      },
      dictOptions: {},
      cancelReason: "",
      crModalvisible: false,
      crConfirmLoading: false,
      isShowExport: false,
      headers: {

        'X-Access-Token': token
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
    rowSelection () {
      const { selectedRowKeys, onSelectChange } = this
      return {
        fixed: true,
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
          props: {
            disabled: (record.docstatus !== 50) && (record.docstatus !== 0),
          },
        }),
      }
    },
  },
  methods: {
    getNewDate(dates, dateStrings) {
      this.queryParam.docdate_begin = dateStrings[0]
      this.queryParam.docdate_end = dateStrings[1]
    },
    checkRoles(roles) {
      const targetRoles = ['visitor_xiamen_admin', 'visitor_chengdu_admin', 'visitor_siyang_admin', 'standard_team_siyang'];
      for (let i = 0; i < roles.length; i++) {
        if (targetRoles.includes(roles[i])) {
          return true;
        }
      }
      return false;
    },
    findRoleByUserNo() {
      getFindRoleByUserNo().then(res => {
        if (res.code == 200) {
          console.log(res, 'resresresresres权限')
          if(res.result && res.result.length != 0) {
            this.isShowExport = this.checkRoles(res.result);
          } else {
            this.isShowExport = false;
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getdatalist () {
      getVisitorConfigList().then(res => {
        console.log("res")
        console.log(res)
        if (res.code == 200) {
          let configArr = res.result.map(item => {
            return {
              key: item.switchCode,
              value: (item.switchStatus === "0") ? true : false
            }
          });
          //配置数组转为对象 方便查询
          let obj = {}
          configArr.forEach(element => {
            obj[element.key] = element.value
          });
          console.log(configArr)
          console.log(obj)
          this.setVisitorConfig(obj)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    async downloadTemplate () {
      ajaxGetDictItems('visitor_hd_import_temp', null).then(res => {
        window.location.href = res.result[0].value
      })
    },
    initDictConfig () {
    },
    handleAdd: function () {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
      this.$refs.modalForm.disableSubmit = false
    },
    handleCancelClick () {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error("请先选中取消拜访的访客")
        return
      }
      this.cancelReason = ""
      this.crModalvisible = true;
    },
    handleCROk () {
      if (!this.cancelReason) {
        this.$message.error("请输入取消的原因")
        return
      }
      this.crConfirmLoading = true
      cancelVistors({
        cancellationReason: this.cancelReason.trim(),
        doccodeArrStr: this.selectedRowKeys.join(",")
      }).then(res => {
        if (res.success === true) {
          this.$message.success("取消成功")
          this.crModalvisible = false
        } else {
          this.$message.success(res.message)
        }
      }).catch(err => {
        if (err && err.message) {
          this.$message.error(err.message)
        }
      }).finally(() => {
        this.crConfirmLoading = false
      })
    },
    handleCRCancel () {
      this.crModalvisible = false;
      this.cancelReason = ""
    },
    handleEditNew (record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = "查看";
      this.$refs.modalForm.disableSubmit = true;
    },
    handleChange (info) {
      if (info.file.status !== 'uploading') {
        console.log('1', info.file, '2', info.fileList);

      }
      if (info.file.status === 'done') {
        this.$message.success(info.file.response.message);
        if (info.file.response.result != "") {
          window.location.href = info.file.response.result.errorExcelUrl
        } else {

          this.searchReset()
        }
        this.$message.success(`${info.file.name}`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name}`);
      }
    },

    ...mapMutations({
      setVisitorConfig: 'SET_VISITOR_CONFIG'
    })
  }
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(1) {
    width: 260px;
  }
  & > *:nth-child(2) {
    width: 260px;
  }
  & > *:nth-child(7) {
    width: 260px;
  }
  & > *:nth-child(n) {
    margin-left: 12px;
  }
  & > .query-banner-btn:nth-child(n) {
    width: 100px;
  }
}
.table-operator {
  margin-top: 30px;
  display: flex;
}
</style>